/**
 * Module dependencies.
 */

import { Button } from 'app/components/atoms/button/button';
import { cn } from 'app/lib/utils';
import React from 'react';

/**
 * Export `Wrapper` component.
 */

export function Wrapper({ className, ...props }: React.HTMLAttributes<HTMLDivElement>): JSX.Element {
  return (
    <div className={cn('flex flex-col md:flex-row', className)} style={{ height: 'calc(100vh - 110px)' }} {...props} />
  );
}

/**
 * Export `NotesContent` component (tree pane).
 */

export function NotesContent({ className, ...props }: React.HTMLAttributes<HTMLDivElement>): JSX.Element {
  return (
    <div
      className={cn('flex h-full w-full flex-col md:w-72 md:shrink-0 md:border-r md:border-border md:pr-2', className)}
      {...props}
    />
  );
}

/**
 * Export `EditorContent` component.
 */

export function EditorContent({ className, ...props }: React.HTMLAttributes<HTMLDivElement>): JSX.Element {
  return <div className={cn('flex h-full w-full min-w-0 flex-1 md:pl-2', className)} {...props} />;
}

/**
 * Export `WrapperTree` component.
 */

export function WrapperTree({ className, ...props }: React.HTMLAttributes<HTMLDivElement>): JSX.Element {
  return <div className={cn('flex w-full flex-1 flex-col', className)} {...props} />;
}

/**
 * Export `StyledButton` component.
 */

export function StyledButton(props: React.ComponentProps<typeof Button>): JSX.Element {
  return <Button {...props} className={cn('flex items-center gap-2', props.className)} />;
}

/**
 * Export `TreeMenu` component.
 */

export function TreeMenu({ className, ...props }: React.HTMLAttributes<HTMLDivElement>): JSX.Element {
  return <div className={cn('mb-4 flex h-8 gap-4 text-xl', className)} {...props} />;
}
